export const FocusRingVariants = {
    Light: 'light',
    Dark: 'dark',
};
//# sourceMappingURL=focusRingVariants.js.map